import * as React from 'react';

import OuchComponent from "./OuchComponent";

import { actions as  TimerActions } from '../redux/modules/timer';
import {connect} from "react-redux";

interface IWebSocketMessage {
    type: string;
    payload: any;
}

interface IExternalProps {
    url: string;

    attemptingReconnect(retry: number): void;
    connect(): void;
    connected(): void;
    disconnected(): void;
    reconnectFailed(): void;

    timerStarted(data: any): void;
    timerStopped(): void;
}

interface IInternalProps {
    tick(team: string, name: string, remainingTime: number, timestamp: number): void;
    stop(team: string): void;
}

type Props = IExternalProps & IInternalProps;

interface IState {
    connected: boolean;
    pending: boolean;
    retries: number;
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {
    ...TimerActions,
}

class WebSocketProvider extends React.Component<Props, IState> {

    public state = {
        connected: false,
        pending: true,
        retries: 0,
    };

    public connection:WebSocket;

    private readonly MAX_RETRIES = 10;
    private readonly FACTOR = 2;
    private readonly WAIT = 500;

    private timeOutId: number = -1;

    public componentDidMount() {
        this.connect();
    }

    public componentWillUnmount(): void {
        this.connection.close();
    }

    public render() {

        if(!this.state.pending && !this.state.connected) {
            return (<OuchComponent/>);
        }

        return (this.props.children);
    }


    private connect() {
        const url: string = this.props.url;
        this.connection = new WebSocket(url);

        this.props.connect();

        this.connection.onmessage = this.onMessage.bind(this)
        this.connection.onerror = () => this.props.reconnectFailed();
        this.connection.onclose = () => {
            this.retry();
            this.props.disconnected();
        };
        this.connection.onopen = () => {
            this.setState({retries: 0, connected: true, pending: false });
            return this.props.connected();
        };
    }

    private retry() {
        if(this.timeOutId > -1) {
            return;
        }

        const retries = this.state.retries + 1;

        this.setState({ retries });

        if (retries <= this.MAX_RETRIES) {
            console.log(`reconnect: ${retries} timeout: ${this.WAIT * this.FACTOR * retries}`);
            this.props.attemptingReconnect(retries);
            this.timeOutId = window.setTimeout(() => {
               this.timeOutId = -1;
               this.connect();
           }, this.WAIT * this.FACTOR * retries);
        } else {
            console.log("max retries limit reached! He's dead Jim!");
            this.setState({ pending: false, connected: false});
            this.props.reconnectFailed();
        }
    }

    private onMessage(e:MessageEvent) {
        if(e.data) {
            try {
                const parsedMessage = JSON.parse(e.data) as IWebSocketMessage;

                switch(parsedMessage.type) {
                    case "timerStarted": {
                        this.props.timerStarted(parsedMessage.payload);
                        break;
                    }
                    case "timerStopped": {
                        const { team } = parsedMessage.payload;
                        this.props.timerStopped();
                        this.props.stop(team);
                        break;
                    }
                    case "tick": {
                        const {name, remainingTime, team, timestamp} = parsedMessage.payload;
                        this.props.tick(team, name, remainingTime, timestamp);
                        break;
                    }
                }
            } catch(e) {
                return;
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketProvider);



// WEBPACK FOOTER //
// ./src/components/WebSocketProvider.tsx